<template>
  <v-container class="mt-0 pt-0" outlined :loading="loading" :disabled="loading">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-card outlined>
          <v-card-title>
            <h3>
              <v-icon class="mr-3" color="primary">mdi-format-list-checks</v-icon>Integrações
            </h3>
          </v-card-title>
          <v-card-text>
            <v-row v-if="!loading && integrationCatalog.length">
              <v-col
                v-for="integration in integrationCatalog"
                :key="integration.id"
                cols="12"
                sm="6"
                md="4"
                lg="3"
                class="d-flex"
              >
                <IntegrationCard
                  :integration="integration"
                  class="flex-grow-1"
                  @click="openIntegration(integration.slug)"
                />
              </v-col>
            </v-row>
            <div v-else-if="!loading" class="text-center py-6 grey--text">
              Nenhuma integração disponível.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import IntegrationCard from "@/components/integrations/IntegrationCard.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    IntegrationCard,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState("configurationIntegration", ["integrationCatalog"]),
  },
  async mounted() {
    await this.loadCatalog();
  },
  methods: {
    ...mapActions("configurationIntegration", ["loadIntegrationCatalog"]),
    async loadCatalog() {
      this.loading = true;
      try {
        await this.loadIntegrationCatalog();
      } catch (error) {
        this.$swal("Oops...", error.message, "error");
      }
      this.loading = false;
    },
    openIntegration(slug) {
      this.$router.push(`/configuration_company/integration/${slug}`);
    },
  },
};
</script>
